import React from 'react';
import { Label } from 'components/shadcn/ui/label';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from 'components/shadcn/ui/select';

export const TableFilter = (props) => {
    const { columns, filterBy, setFilterBy, setSortField, onSearchChange } =
        props;

    const onSetSearchBy = (value) => {
        if (value) {
            const accessor = columns?.find(
                (column) => column.accessor === value
            )?.accessor;
            setFilterBy(accessor);
            setSortField(accessor);
        }
        onSearchChange('');
    };

    return (
        <div className="w-full sm:w-max">
            <Label
                id="search-by"
                className="text-xs font-normal text-foreground"
            >
                Search By
            </Label>
            <Select
                id="search-by"
                name="search-by"
                value={filterBy || undefined}
                onValueChange={onSetSearchBy}
                className="min-h-[45px]"
            >
                <SelectTrigger className="w-full gap-1 data-[placeholder]:text-muted-foreground sm:w-[155px]">
                    <SelectValue placeholder="Select a column" />
                </SelectTrigger>
                <SelectContent className="w-full sm:w-[155px]">
                    {columns?.map((column) => (
                        <SelectItem
                            key={column.accessor}
                            value={column.accessor}
                            id={`search-by-${column.accessor}`}
                        >
                            {column.Header}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
};
